import axios from "axios";
import { Convert } from "@/utils/convert";

export default class UserService {

    get(userId) {
        return axios.get(`/api/v4/users/${userId}`)
            .then(response => response.data, err => Promise.reject(err.response.data));
    }

    getSummary(nameContains) {
        return axios.get(`/api/v4/users?summarized=true&name_contains=${nameContains}`)
            .then(response => response.data, err => Promise.reject(err.response.data));
    }

    editUser(userId, updateRequest) {
      return axios.patch(`/api/v4/users/${userId}`, updateRequest)
        .then(response => response.data, err => Promise.reject(err.response.data));
    }

    clearNotifications(userId) {
        return axios.delete(`/api/v4/users/${userId}/notifications`)
            .then(response => response.data, err => Promise.reject(err.response.data));
    }

    saveQualification(userId, qualification) {

        const qualificationCopy = { ...qualification };
        delete qualificationCopy.edit;
        delete qualificationCopy.userIds;

        let promise;

        if (qualificationCopy.id) {
            const dateAdaptedQualification = { 
                ...qualificationCopy, 
                ...{
                    completionDate: Convert.assumeLocalDateAsUTCDate(qualificationCopy.completionDate)
                }
            };

            promise = axios.put(`/api/v4/users/${userId}/qualifications/${qualificationCopy.id}`, dateAdaptedQualification);
        } else {
            promise = axios.post(`/api/v4/users/${userId}/qualifications`, qualificationCopy);
        }

        return promise.then(
            resp => {
                const id = resp.data.id;
                
                if (qualificationCopy.file && qualificationCopy.file.size) {
                    var formData = new FormData();
                    formData.append("qualificationFile", qualificationCopy.file);

                    return axios.put(`/api/v4/users/${userId}/qualifications/${id}/attachment`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                        .then(r => r.data, err => Promise.reject(err.response.data))
                }
            },
            err => Promise.reject(err.response)
        );
    }

    deleteQualification(userId, qualificationId) {
        return axios.delete(`/api/v4/users/${userId}/qualifications/${qualificationId}`)
            .then(response => response.data, err => Promise.reject(err.response.data));
    }

    getAccessTemplates() {
        return axios.get(`/api/v4/users/templates`)
            .then(response => response.data, err => Promise.reject(err.response.data));
    }
}